"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentResolver = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const withLazy_1 = __importDefault(require("../../../common/decorators/withLazy"));
const helpers_1 = require("../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const FolderDetail_1 = __importDefault(require("../Detail/FolderDetail"));
const CallArea_1 = __importDefault(require("../../../common/components/CallToActions/CallArea"));
const EmailArea_1 = __importDefault(require("../../../common/components/CallToActions/EmailArea"));
const BookingArea_1 = __importDefault(require("../../../common/components/CallToActions/Booking/BookingArea"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const NoMatch_1 = __importDefault(require("../../../common/components/Other/NoMatch"));
const Map = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(
/* webpackChunkName: "Map2" */ "../../../common/components/CallToActions/Map")))));
const ShoppingCart = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(
/* webpackChunkName: "ShoppingCart1358763900008" */ "../ShoppingCart/ShoppingCart")))));
const ContentResolver = (props) => {
    const [contentData, setContentData] = (0, react_1.useState)({});
    const [modalOpenWasRequested, setModalOpenWasRequested] = (0, react_1.useState)(false);
    const [modalContent, setModalContent] = (0, react_1.useState)({});
    // eslint-disable-next-line no-unused-vars
    const [isSearching, setIsSearching] = (0, react_1.useState)(true);
    const { type, name, action } = props.match.params;
    const { dataFetchCompleted } = props;
    const currentPath = window.location.pathname;
    const currentUrl = action
        ? currentPath.substring(0, currentPath.lastIndexOf(`/${action}`))
        : currentPath;
    const contentId = name
        ? name
            .split("-")
            .pop()
            .slice(type ? 0 : 12)
        : "";
    const updateContentData = (data) => {
        setContentData(data);
        if (dataFetchCompleted) {
            setIsSearching(false);
        }
    };
    const searchContentInTreeStructure = (node, parent = {}) => {
        const nodes = node.children;
        if (!type) {
            setContentData(node);
            return;
        }
        nodes.map((iteratedNode) => {
            const nodeType = Object.keys(iteratedNode)[0];
            if (nodeType === "pccaddiepage") {
                return iteratedNode;
            }
            const nodeDeeplink = new URL(iteratedNode[nodeType].deeplink);
            if (nodeDeeplink.pathname === currentUrl ||
                (type === nodeType &&
                    iteratedNode[nodeType].id.toString() === contentId)) {
                // if the found item is not a folder that means we should open a modal,
                // therefore we set the modalcontent to the found item BUT the
                // list items in the background ( contentData ) do not change
                if (type === "folder") {
                    setContentData(iteratedNode[nodeType]);
                }
                else {
                    setContentData(parent);
                    setModalContent(iteratedNode[nodeType]);
                }
                return iteratedNode;
            }
            if (nodeType === "folder") {
                searchContentInTreeStructure(iteratedNode[nodeType], iteratedNode[nodeType]);
            }
            return iteratedNode;
        });
        if (dataFetchCompleted) {
            setIsSearching(false);
        }
    };
    const getActivityFullData = (id) => apiService_1.default.getActivity(props.currentLocale, props.userData.token, id);
    const searchContentInActivities = () => __awaiter(void 0, void 0, void 0, function* () {
        if (process.env.PLATFORM === "webapp") {
            const contentFullId = `-${currentUrl.split("--").pop()}`;
            const activityFullData = yield getActivityFullData(contentFullId);
            updateContentData(activityFullData);
        }
    });
    const searchContentInBrandInfo = (nodes) => {
        nodes.map((node) => {
            const nodeType = Object.keys(node)[0];
            if (name === node[nodeType].title.toLowerCase().replace(/ /g, "-")) {
                setContentData(node[nodeType]);
                return node;
            }
            if (nodeType === "folder") {
                searchContentInBrandInfo(node[nodeType].children);
            }
            return node;
        });
        if (dataFetchCompleted) {
            setIsSearching(false);
        }
    };
    const resolveContent = () => {
        if (props.collection === "brand") {
            searchContentInBrandInfo(props.brand);
        }
        else if (type) {
            searchContentInTreeStructure({
                children: props[props.collection],
                type: "folder",
                deeplink: `http://localhost:8080${props.baseUrl}/${props.collection === "directories" ? "directory" : props.collection}`,
            }, {
                children: props[props.collection],
                type: "folder",
                deeplink: `http://localhost:8080${props.baseUrl}/${props.collection === "directories" ? "directory" : props.collection}`,
            });
        }
        else if (props.collection === "activities") {
            searchContentInActivities();
        }
        else {
            searchContentInTreeStructure({
                children: props[props.collection],
                type: "folder",
                deeplink: `http://localhost:8080${props.baseUrl}/${props.collection === "directories" ? "directory" : props.collection}`,
            }, {
                children: props[props.collection],
                type: "folder",
                deeplink: `http://localhost:8080${props.baseUrl}/${props.collection === "directories" ? "directory" : props.collection}`,
            });
        }
    };
    (0, react_1.useEffect)(() => {
        const requestModalOpen = () => {
            setModalOpenWasRequested(true);
        };
        window.addEventListener("modalOpenWasRequested", requestModalOpen);
        return () => {
            window.removeEventListener("modalOpenWasRequested", requestModalOpen);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        resolveContent();
    }, [props.location.pathname]);
    (0, react_1.useEffect)(() => {
        resolveContent();
    }, [props.directories, props.offers]);
    (0, react_1.useEffect)(() => {
        if (props.dataFetchCompleted) {
            resolveContent();
        }
    }, [props.dataFetchCompleted]);
    (0, react_1.useEffect)(() => {
        const redirectLocation = contentData.deeplink
            ? new URL(contentData.deeplink).pathname
            : null;
        if (modalContent.type === "offer" ||
            modalContent.type === "page" ||
            modalContent.type === "document" ||
            modalContent.type === "website") {
            helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                activeItem: modalContent,
                redirectOnClose: redirectLocation,
            });
        }
        setModalOpenWasRequested(false);
    }, [modalContent, modalOpenWasRequested]);
    // for hotfix HM-3886 the next lines will be commented
    // if ( isSearching ) {
    //     return <Loader />;
    // }
    if (!Object.prototype.hasOwnProperty.call(contentData, "type") &&
        !isSearching) {
        return react_1.default.createElement(NoMatch_1.default, null);
    }
    if (Object.keys(contentData).length === 0) {
        return null;
    }
    if (action) {
        switch (action) {
            case "call":
                return (react_1.default.createElement(CallArea_1.default, { activeItem: { content: contentData, type: contentData.type } }));
            case "map":
                return (react_1.default.createElement(Map, { activeItem: { content: contentData, type: contentData.type } }));
            case "cart":
                return (react_1.default.createElement(ShoppingCart, { activeItem: { content: contentData, type: contentData.type } }));
            case "book":
            case "walkin_registration":
                return (react_1.default.createElement(BookingArea_1.default, { activeItem: { content: contentData, type: contentData.type }, walkinRegistration: action === "walkin_registration" }));
            default:
                return (react_1.default.createElement(EmailArea_1.default, { activeItem: { content: contentData, type: contentData.type } }));
        }
    }
    return react_1.default.createElement(FolderDetail_1.default, { folderContent: contentData });
};
exports.ContentResolver = ContentResolver;
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
    directories: store.getValue("directory"),
    offers: store.getValue("offers"),
    brand: store.getValue("brandInfo"),
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
    dataFetchCompleted: store.getValue("dataFetchCompleted"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ContentResolver));
